import type { StandardCart } from '@/types/ShopFront/CheckoutStandards'
import { lineItemStandardizerInput, standardizeLineItem } from './standardizeLineItem'
import { isShipshieldEligibleByAmount, isShipshieldEligibleByItems } from '../../helpers/shipshieldEligibility'

type CartStandardizerInput = {
  lineItems: unknown[],
  baseAmount: number,
  cartAmount: number,
  discountAmount: number,
  customerId: number,
  email: string,
  id: string,
  updatedTime: string,
  coupons: readonly {
    id: number,
    code: string,
    displayName: string,
    couponType: string,
    discountedAmount: number,
  }[]
}
export type CartStandardizer = (input: CartStandardizerInput) => StandardCart

export const standardizeCart: CartStandardizer = ({
  lineItems,
  baseAmount,
  cartAmount,
  customerId,
  discountAmount,
  email,
  id,
  updatedTime,
  coupons = [],
}) => ({
  lineItems: lineItems.map(standardizeLineItem),
  coupons: [...coupons],
  subtotal: baseAmount,
  total: cartAmount,
  discount: discountAmount,
  customerId,
  email,
  id,
  updatedTime,
  shippedShieldAvailable: isShipshieldEligibleByAmount({
    cartBaseAmount: baseAmount,
    lineItems: lineItems as lineItemStandardizerInput[],
  }) && isShipshieldEligibleByItems(
    lineItems as lineItemStandardizerInput[],
  ),
})
